import React from 'react';

import { Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';

import { Link } from 'react-router-dom';


import { getStatusClassAndText, isWithinDateRange, alert, getCatalog, getCertificationType } from 'utils';

import emetCertImg from 'assets/img/support-desk/reports/5.png';
import epstCertImg from 'assets/img/support-desk/reports/6.png';

import moment from 'moment-timezone';





const CertificationItem = ({cert}) => {
    const { text, className } = getStatusClassAndText(cert.status, cert.assigned_date, cert.closed_date);

    return (
		<Col lg={6}
			xxl={6}>
			<Flex alignItems="center" className="px-4 py-x1 bg-light rounded-3 border position-relative">
				<img src={ cert.catalog_id === 1 ? epstCertImg : emetCertImg}
					alt=""
					width="39"/>
				<div className="ms-3 my-x1">
					<h5 className="fs-0 fw-semi-bold mb-2">
                        <Link
                            to={
                                (cert.status === 2 || cert.status === 3)
                                    ? (cert.catalog_id === 2
                                        ? "/certification/result/emet"
                                        : "/certification/result/epst")
                                    : "/certification/indications"
                            }
                            state={{ ...cert }}
                            className="text-900 hover-primary stretched-link"
                            onClick={(e) => {
                                if (cert.status === 1) {
                                    e.preventDefault();
                                    alert("", "No es posible acceder a una certificación en proceso.", "warning");
                                } else if (cert.status === 5 || cert.status === 4) {
                                    e.preventDefault();
                                    alert("", "No se puede acceder a la certificación debido a un error. Por favor, contacte a soporte técnico.", "error");
                                } else if (cert.status === 0 && !isWithinDateRange(cert.assigned_date, cert.closed_date)) {
                                    e.preventDefault();
                                    alert("", "La certificación no está disponible en la fecha actual.", "warning");
                                }
                            }}
                        >
                            {getCatalog(cert.catalog_id)}
                            {cert.description}
                        </Link>
					</h5>
					{/* <h6 className="mb-0 text-600">{cert.description}</h6> */}
					<h6 className="mb-0 text-600 mt-1">
                        {`Tipo: ${ getCertificationType(cert.certification_type) }`}
                    </h6>
                    <h6 className={`mb-0 mt-1 ${className}`}>
                        {`Estado: ${text}`}
                    </h6>
                    <h6 className="mb-0 text-600 mt-1">
                        {cert.status === 0 ? 
                            `Disponible desde ${moment.utc(cert.assigned_date).format('DD/MM/YYYY')} hasta ${moment.utc(cert.closed_date).format('DD/MM/YYYY')}` 
                            : cert.status === 1 ? 
                            `Iniciado el ${moment.utc().format('DD/MM/YYYY')}` 
                            : `Finalizado el ${moment.utc(cert.completed_date).format('DD/MM/YYYY HH:mm:ss')}`
                        }
                    </h6>
				</div>
			</Flex>
		</Col>
	);
};

export default CertificationItem;
